module.exports = __webpack_public_path__ + "static/media/1_en.c7be78fb.png";